exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-8813bd56]{-webkit-box-sizing:border-box;box-sizing:border-box}.container[data-v-8813bd56]{height:100%;width:100%;margin:0;font-family:Source Han Sans SC;background-color:#eff3f5;padding-top:2.8vw;position:relative;overflow:auto}.container[data-v-8813bd56]::-webkit-scrollbar{width:5px}.container[data-v-8813bd56]::-webkit-scrollbar-thumb{border-radius:10px;background:rgba(0,0,0,.2)}.container[data-v-8813bd56]::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px rgba(0,0,0,.2);border-radius:10px;background:rgba(0,0,0,.1)}#map[data-v-8813bd56]{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8813bd56","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/index.vue
// module id = 4BJU
// module chunks = 24